import {
    CLUBS_POST_FAILURE,
    CLUBS_POST_REQUEST,
    CLUBS_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const clubPostReducer = (state = initialState, action) => {
    const {type, club} = action;
    switch (type) {
        case CLUBS_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            club,
        }}

        case CLUBS_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case CLUBS_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
